export default "<div class=\"progress-loader\" [hidden]=\"!loading\">\n    <mat-spinner diameter=\"100\" color=\"primary\"></mat-spinner>\n</div>";